const hook = {
    missing_events: 'Вы должны предоставить как минимум одно событие.',
    send_test_payload_failed: 'Не удалось отправить тестовую нагрузку: {{message}}',
    endpoint_responded_with_error: 'Конечная точка ответила ошибкой.',
};
export default Object.freeze(hook);
